import React from 'react';
import { FadeInView } from '../ui/FadeInView';
import { CTAButton } from '../ui/CTAButton';
export function TestimonialsFAQSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#F5F0E8] text-center relative overflow-hidden" data-id="element-320">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-321">
        <FadeInView data-id="element-322">
          {/* FAQ */}
          <div className="mb-20" data-id="element-323">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B4332] mb-10 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-324">
              ❓ PREGUNTAS FRECUENTES
            </h2>

            <div className="space-y-4 text-left max-w-3xl mx-auto" data-id="element-325">
              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-326">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-327">
                  ¿Cómo recibo el MegaPack después de comprar?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-328">
                  Recibes un email con acceso inmediato a todos los archivos
                  PDF. En menos de 5 minutos tienes todo en tu dispositivo.
                </p>
              </div>

              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-329">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-330">
                  ¿Necesito una Air Fryer específica?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-331">
                  No. El sistema funciona con cualquier marca y modelo. La Guía
                  de Cocción incluida se adapta a todos los modelos.
                </p>
              </div>

              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-332">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-333">
                  ¿Es apto si tengo intolerancia al gluten o soy vegetariano?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-334">
                  Sí. Los 6 libros incluyen variantes para diferentes
                  necesidades. Muchas recetas son naturalmente sin gluten y hay
                  opciones vegetarianas en todos los libros.
                </p>
              </div>

              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-335">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-336">
                  ¿Tengo que contar calorías?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-337">
                  No. Las recetas y el plan semanal ya están equilibrados. Solo
                  tienes que cocinar y comer.
                </p>
              </div>

              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-338">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-339">
                  ¿Funciona si tengo poco tiempo?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-340">
                  Especialmente para personas con poco tiempo. Ninguna receta
                  supera los 20 minutos. El Batch Cooking te permite resolver
                  toda la semana en una sola tarde del domingo.
                </p>
              </div>

              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-341">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-342">
                  ¿Qué diferencia hay entre las dos opciones?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-343">
                  El MegaPack Base es el sistema completo para adelgazar. El
                  Pack Completo con AIR‑FAST 7 añade el programa de aceleración
                  de 21 días para resultados más rápidos desde el primer mes.
                </p>
              </div>

              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-344">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-345">
                  ¿En qué formato están los libros?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-346">
                  Todos en PDF. Compatibles con móvil, tablet u ordenador. Sin
                  aplicaciones adicionales.
                </p>
              </div>

              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-347">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-348">
                  ¿Cuándo recibo el material?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-349">
                  Inmediatamente después de completar la compra.
                </p>
              </div>

              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-350">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-351">
                  ¿Cuáles son los métodos de pago?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-352">
                  Aceptamos tarjeta de crédito y débito — Visa y Mastercard — y
                  PayPal. Pago 100% seguro y encriptado.
                </p>
              </div>
            </div>
          </div>

          {/* FINAL DECISION NARRATIVE */}
          <div className="mb-16" data-id="element-353">
            <h2 className="text-3xl md:text-5xl font-bold text-[#1B4332] mb-8 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-354">
              Cada día que pasa sin un sistema es un día más de lo mismo.
            </h2>

            <p className="text-lg md:text-xl text-[#2D5016]/80 mb-8 leading-relaxed" data-id="element-355">
              Mañana por la mañana vas a abrir la nevera. Y va a pasar una de
              estas dos cosas:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-356">
              <div className="bg-[#FAF7F2] p-8 rounded-3xl border border-[#D4A853]/20 shadow-sm" data-id="element-357">
                <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-358">
                  Opción A
                </h3>
                <p className="text-[#2D5016]/80 leading-relaxed" data-id="element-359">
                  Vas a improvisar otra vez. Vas a comer lo que encuentres. Vas
                  a llegar a la noche con culpa. Y el lunes que viene vas a
                  volver a empezar la misma dieta de siempre.
                </p>
              </div>

              <div className="bg-gradient-to-b from-[#1B4332] to-[#2D5016] p-8 rounded-3xl border border-[#D4A853] shadow-2xl" data-id="element-360">
                <h3 className="text-2xl font-bold text-[#D4A853] mb-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-361">
                  Opción B
                </h3>
                <p className="text-[#FAF7F2] leading-relaxed" data-id="element-362">
                  Vas a abrir el plan semanal. Vas a saber exactamente qué
                  desayunar, qué comer y qué cenar. Vas a usar tu Air Fryer para
                  preparar algo rico en 15 minutos. Y por primera vez en mucho
                  tiempo vas a terminar el día sin culpa.
                </p>
              </div>
            </div>

            <p className="text-2xl md:text-3xl font-bold text-[#1B4332] mb-12" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-363">
              La Air Fryer ya la tienes en casa. El sistema lo tienes aquí. La
              decisión la tienes tú.
            </p>
          </div>

          {/* FINAL PRICING CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-364">
            {/* Option 1 */}
            <div className="bg-[#FAF7F2] rounded-3xl p-8 border border-[#D4A853]/20 shadow-sm" data-id="element-365">
              <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-366">
                OPCIÓN 1 — MEGAPACK BASE
              </h3>
              <p className="text-lg text-[#2D5016] mb-4" data-id="element-367">6 Libros + 3 Bonos</p>
              <p className="text-sm text-[#1B4332]/50 line-through mb-2" data-id="element-368">
                49,00€
              </p>
              <p className="text-5xl font-bold text-[#2D5016] mb-6" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-369">
                16,99€
              </p>
              <CTAButton href="https://pagos.digipromarket.com/cart/56222402937158:1" text="→ QUIERO EL MEGAPACK BASE" data-id="element-370" />
            </div>

            {/* Option 2 */}
            <div className="bg-gradient-to-b from-[#1B4332] to-[#2D5016] rounded-3xl p-8 border-2 border-[#D4A853] shadow-2xl relative" data-id="element-371">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#D4A853] text-[#1B4332] font-bold px-6 py-2 rounded-full text-sm tracking-widest uppercase shadow-md whitespace-nowrap" data-id="element-372">
                ⭐ LA MÁS ELEGIDA
              </div>
              <h3 className="text-2xl font-bold text-[#D4A853] mb-4 mt-4" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-373">
                🏆 OPCIÓN 2 — PACK COMPLETO + AIR‑FAST 7
              </h3>
              <p className="text-lg text-[#FAF7F2] mb-4" data-id="element-374">
                6 Libros + 3 Bonos + Sistema AIR‑FAST 7
              </p>
              <p className="text-sm text-[#FAF7F2]/50 line-through mb-2" data-id="element-375">
                78,00€
              </p>
              <p className="text-5xl font-bold text-[#D4A853] mb-6" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-376">
                23,99€
              </p>
              <a href="https://pagos.digipromarket.com/cart/56222886723910:1" className="block w-full bg-[#D4A853] hover:bg-[#B8935C] text-[#1B4332] font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-sm text-center cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]" data-id="element-377">
                → QUIERO EL PACK COMPLETO CON AIR‑FAST 7
              </a>
            </div>
          </div>

          {/* TRUST BADGES */}
          <div className="flex flex-wrap justify-center items-center gap-6 mb-12 text-[#1B4332] font-medium" data-id="element-378">
            <span className="flex items-center gap-2" data-id="element-379">
              <span className="text-xl" data-id="element-380">🔒</span> Pago 100% seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-381">
              <span className="text-xl" data-id="element-382">⚡</span> Acceso en 5 minutos
            </span>
            <span className="flex items-center gap-2" data-id="element-383">
              <span className="text-xl" data-id="element-384">🛡️</span> Garantía 7 días sin preguntas
            </span>
            <span className="flex items-center gap-2" data-id="element-385">
              <span className="text-xl" data-id="element-386">💳</span> Tarjeta Visa y Mastercard |
              PayPal
            </span>
          </div>

          {/* FOOTER */}
          <div className="border-t border-[#D4A853]/20 pt-8" data-id="element-387">
            <p className="text-lg font-bold text-[#1B4332] mb-4" data-id="element-388">
              🍗 Adelgaza con Air Fryer — Todos los derechos reservados
            </p>
            <p className="text-sm text-[#2D5016]/60 leading-relaxed" data-id="element-389">
              Precios en euros. Pago procesado de forma segura y encriptada.
              Este producto es un infoproducto digital en formato PDF. No es un
              servicio médico ni nutricional. Los resultados pueden variar según
              cada persona.
            </p>
          </div>
        </FadeInView>
      </div>
    </section>;
}